import { useApi } from '@gravitate-js/the-armory'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
export const useDriverAnalytics = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useDriverAnalyticsQuery = (payload) =>
    useQuery({
      queryKey: ['getDriverAnalyticsQuery', payload],
      queryFn: ({ queryKey }) => api.post('driver_analytics/driver_analytics', queryKey[1]),
      enabled: !!payload,
    })

  const useDriverResourceQuery = (payload: { start_date: string; end_date: string }) =>
    useQuery({
      queryKey: ['getDriverResourceQuery', payload],
      queryFn: ({ queryKey }) => api.post('driver/resource_planner', payload),
      enabled: !!payload,
    })

  return {
    useDriverAnalyticsQuery,
    useDriverResourceQuery,
  }
}
